export default "__VITE_ASSET__13b8dc72__"